import { render, staticRenderFns } from "./jygz.vue?vue&type=template&id=43b9f1e1&scoped=true&"
import script from "./jygz.vue?vue&type=script&lang=js&"
export * from "./jygz.vue?vue&type=script&lang=js&"
import style0 from "./jygz.vue?vue&type=style&index=0&id=43b9f1e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b9f1e1",
  null
  
)

export default component.exports